// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"492":"e59386f5","606":"c2f890f6"}[chunkId] + ".css";
};